import React from 'react'
import Navigation from "../navigation/Navigation";

export default class Root extends React.Component {
    render() {
        return (
            <div id="wrapper">
                <Navigation />
                <div id="page-wrapper" className="routerView">{this.props.children}</div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/base/Root.js